/**
 * 工作流时间展示工具。
 *
 * 约定：后端入库 UTC，API 已输出东八区墙钟 ``YYYY-MM-DD HH:mm:ss``。
 * 前端仅做空值兜底与原样展示，不再做时区换算。
 */
export function formatShanghaiDateTime(value: string | number | Date | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return '-'
  }
  if (typeof value === 'string') {
    return value.trim() || '-'
  }
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) {
      return '-'
    }
    // 兜底：若误传入 Date，按东八区格式化（正常路径应为后端字符串）
    const parts = new Intl.DateTimeFormat('zh-CN', {
      timeZone: 'Asia/Shanghai',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(value)
    const byType = new Map(parts.map((part) => [part.type, part.value]))
    return `${byType.get('year')}-${byType.get('month')}-${byType.get('day')} ${byType.get('hour')}:${byType.get('minute')}:${byType.get('second')}`
  }
  return String(value)
}

/**
 * 解析后端东八区展示串或 ISO 串为时间戳，仅用于排序比较。
 * 东八区墙钟无后缀时按 +08:00 解释，避免被浏览器当成本地/UTC 误读。
 */
export function parseWorkflowDisplayTimestamp(value: string): number {
  const trimmed = value.trim()
  if (!trimmed) return 0
  if (/(Z|[+-]\d{2}:?\d{2})$/i.test(trimmed)) {
    const ts = new Date(trimmed).getTime()
    return Number.isNaN(ts) ? 0 : ts
  }
  const naiveMatch = /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}:\d{2}(?:\.\d+)?)$/.exec(trimmed)
  if (naiveMatch) {
    const ts = new Date(`${naiveMatch[1]}T${naiveMatch[2]}+08:00`).getTime()
    return Number.isNaN(ts) ? 0 : ts
  }
  const ts = new Date(trimmed).getTime()
  return Number.isNaN(ts) ? 0 : ts
}
